/**
 * Chess Piece Component (Tailwind CSS)
 * Tailwind variant - filled symbols with contrasting colors
 */
import type { PieceProps } from "../../types";
import { PieceBase } from "./PieceBase";

export function PieceTailwind({ piece }: PieceProps) {
  const style: React.CSSProperties =
    piece.color === "WHITE"
      ? {
          color: "var(--cn-chess-piece-white)",
          WebkitTextStroke: "1px var(--cn-chess-piece-white-stroke)",
          filter: "drop-shadow(1px 1px 1px rgba(0,0,0,0.3))",
        }
      : {
          color: "var(--cn-chess-piece-black)",
          filter: "drop-shadow(1px 1px 1px rgba(0,0,0,0.15))",
        };

  return <PieceBase piece={piece} className="chess-piece" style={style} />;
}
